import { render, staticRenderFns } from "./OurDXBankSolutionsLogoComponent.vue?vue&type=template&id=87203c70&"
import script from "./OurDXBankSolutionsLogoComponent.vue?vue&type=script&lang=js&"
export * from "./OurDXBankSolutionsLogoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports